<template>
    <div id="app">
        <!-- <img "./assets/logo.png"> -->
        <router-view />
    </div>
</template>
<script>
export default {
    name: "App",
    data() {
        return {
            flag: "pc"
        };
    },
    components: {},
    mounted() {
        if (this.isMobile()) {
            // 手机端
            sessionStorage.setItem("flag", "app");
            this.flag = "app";
        } else {
            // pc端
            sessionStorage.setItem("flag", "pc");
            this.flag = "pc";
        }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
        }
    }
};
</script>

<style lang="less">
body,
html {
    width: 100%;
    height: 100%;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000 !important;
    width: 100%;
    height: 100%;
}

.map {
    .el-dialog__body {
        height: 1000px;
    }
}

.operate {
    .el-dialog {
        background: transparent;
        box-shadow: none;
    }
    .name {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: #fff;
        text-align: center;
        line-height: 150px;
        position: relative;
        > span {
            width: 75px;
            height: 150px;
            display: inline-block;
            margin: 0 -1px;
        }
        > span::before {
            content: "";
            height: 75px;
            width: 75px;
            border-radius: 50%;
            background: #fff;
            display: block;
            position: absolute;
        }
        .xm {
            //   background: red;

            border-radius: 75px 0px 0 75px;
        }
        .xm::before {
            right: 35px;
            //   background: red;
        }
        .spousse {
            //   background: blue;

            border-radius: 0 75px 75px 0;
        }
        .spousse::before {
            left: 35px;
            bottom: 0;
            //   background: blue;
        }
        p {
            width: 150px;
            // height: 75px;
            // line-height: 75px;
            position: absolute;
            border-radius: 50%;
            background: #fff;
            font-size: 20px;
        }
    }

    .selector {
        ul {
            position: absolute;
            list-style: none;
            padding: 0;
            margin: 0;
            top: -50px;
            right: -50px;
            bottom: -50px;
            left: -50px;
            li {
                position: absolute;
                width: 0;
                height: 100%;
                margin: 0 50%;
                -webkit-transform: rotate(-360deg);
                transition: all 0.8s ease-in-out;
                button {
                    position: absolute;
                    left: 50%;
                    bottom: 100%;
                    transform: translate(-50%);
                }
            }
            li::after {
                content: "";
                display: block;
                height: 48px;
                border: 1px solid #000;
            }
        }
    }

    .son {
        background-color: #e6a23c;
        border-color: #e6a23c;
    }
    .sisters {
        background-color: #ff007a;
        border-color: #ff007a;
    }
    .daughter {
        background-color: #ff00de;
        border-color: #ff00de;
    }

    .one {
        li:nth-child(2) {
            transform: rotate(-90deg);
        }
        li:nth-child(3) {
            transform: rotate(-180deg);
        }
        li:nth-child(4) {
            transform: rotate(-270deg);
        }
        li:nth-child(2) button {
            transform: translate(-50%) rotate(90deg);
        }
        li:nth-child(3) button {
            transform: translate(-50%) rotate(180deg);
        }
        li:nth-child(4) button {
            transform: translate(-50%) rotate(270deg);
        }
    }

    .two {
        li:nth-child(2) {
            transform: rotate(72deg);
        }
        li:nth-child(3) {
            transform: rotate(144deg);
        }
        li:nth-child(4) {
            transform: rotate(216deg);
        }
        li:nth-child(5) {
            transform: rotate(288deg);
        }
        li:nth-child(6) {
            transform: rotate(300deg);
        }

        li:nth-child(2) button {
            transform: translate(-50%) rotate(0deg);
        }
        li:nth-child(4) button,
        li:nth-child(5) button {
            transform: translate(-50%) rotate(180deg);
        }
    }

    .tree {
        li:nth-child(2) {
            transform: rotate(-120deg);
        }
        li:nth-child(3) {
            transform: rotate(120deg);
        }
        li:nth-child(3) button {
            transform: translate(-50%);
        }
    }
}
.operateApp {
    .el-dialog {
        background: transparent;
        box-shadow: none;
    }
    .name {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        background: #fff;
        text-align: center;
        line-height: 110px;
        position: relative;
        > span {
            width: 55px;
            height: 110px;
            display: inline-block;
            margin: 0 -1px;
        }
        > span::before {
            content: "";
            height: 55px;
            width: 55px;
            border-radius: 50%;
            background: #fff;
            display: block;
            position: absolute;
        }
        .xm {
            //   background: red;

            border-radius: 55px 0px 0 55px;
        }
        .xm::before {
            right: 30px;
            //   background: red;
        }
        .spousse {
            //   background: blue;

            border-radius: 0 55px 55px 0;
        }
        .spousse::before {
            left: 30px;
            bottom: 0;
            //   background: blue;
        }
        p {
            width: 110px;
            // height: 75px;
            // line-height: 75px;
            position: absolute;
            border-radius: 50%;
            background: #fff;
            font-size:18px;
        }
    }

    .selector {
        ul {
            position: absolute;
            list-style: none;
            padding: 0;
            margin: 0;
            top: -50px;
            right: -50px;
            bottom: -50px;
            left: -50px;
            li {
                position: absolute;
                width: 0;
                height: 100%;
                margin: 0 50%;
                -webkit-transform: rotate(-360deg);
                transition: all 0.8s ease-in-out;
                button {
                    position: absolute;
                    left: 50%;
                    bottom: 100%;
                    transform: translate(-50%);
                }
            }
            li::after {
                content: "";
                display: block;
                height: 48px;
                border: 1px solid #000;
            }
        }
    }

    .son {
        background-color: #e6a23c;
        border-color: #e6a23c;
    }
    .sisters {
        background-color: #ff007a;
        border-color: #ff007a;
    }
    .daughter {
        background-color: #ff00de;
        border-color: #ff00de;
    }

    .one {
        li:nth-child(2) {
            transform: rotate(-90deg);
        }
        li:nth-child(3) {
            transform: rotate(-180deg);
        }
        li:nth-child(4) {
            transform: rotate(-270deg);
        }
        li:nth-child(2) button {
            transform: translate(-50%) rotate(90deg);
        }
        li:nth-child(3) button {
            transform: translate(-50%) rotate(180deg);
        }
        li:nth-child(4) button {
            transform: translate(-50%) rotate(270deg);
        }
    }

    .two {
        li:nth-child(2) {
            transform: rotate(72deg);
        }
        li:nth-child(3) {
            transform: rotate(144deg);
        }
        li:nth-child(4) {
            transform: rotate(216deg);
        }
        li:nth-child(5) {
            transform: rotate(288deg);
        }
        li:nth-child(6) {
            transform: rotate(300deg);
        }

        li:nth-child(2) button {
            transform: translate(-50%) rotate(0deg);
        }
        li:nth-child(4) button,
        li:nth-child(5) button {
            transform: translate(-50%) rotate(180deg);
        }
    }

    .tree {
        li:nth-child(2) {
            transform: rotate(-120deg);
        }
        li:nth-child(3) {
            transform: rotate(120deg);
        }
        li:nth-child(3) button {
            transform: translate(-50%);
        }
    }
}
/* 地图搜索 */
.amap-sug-result {
    z-index: 9999;
}
/*九族五服图 */
.fivefu {
    .el-table {
        .el-table__body-wrapper {
            height: calc(100% - 34px);
        }
        .el-table__cell {
            padding: 5px 0;
        }
    }
}

.lineh {
    label {
        line-height: 22px !important;
    }
}

.viewer-backdrop {
    background-color: rgba(0, 0, 0, 80%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue